import { Button } from '../../../../components/Clickables/Buttons/Button';
import { Heading } from '../../../../components/Heading/Heading';
import { Modal } from '../../../../components/Modal/Modal';
import { ModalBody } from '../../../../components/Modal/ModalBody';
import { Text } from '../../../../components/Text/Text';

interface NoChangesModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  dataTestId?: string;
}

export const NoChangesModal = ({ isOpen, setIsOpen, dataTestId }: NoChangesModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      disableClose
      dataTestId={dataTestId}
    >
      <ModalBody>
        <Heading variant="sm" className="mt-5 mb-4">
          No suggested changes added
        </Heading>
        <Text>Add changes in order to submit</Text>
        <Button
          className="w-full"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          ok
        </Button>
      </ModalBody>
    </Modal>
  );
};
